module.exports = __webpack_public_path__ + "static/img/SearchDetailRecruit2.ba90cd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailRecruit2.png
// module id = 771
// module chunks = 0